import { rgba } from "polished"
import styled from "styled-components"
import colors from "styles/colors"

const BACKDROP_ALPHA = 0.88

export const Backdrop = styled.div<{ $isOpen: boolean }>`
  align-items: center;
  background: ${rgba(colors.black, BACKDROP_ALPHA)};
  display: flex;
  inset: 0;
  justify-content: center;
  opacity: ${({ $isOpen }) => {
    if ($isOpen) return 1
    return 0
  }};
  pointer-events: ${({ $isOpen }) => {
    if ($isOpen) return "auto"
    return "none"
  }};
  overflow: auto;
  padding: 32px 24px;
  position: fixed;
  transition: opacity 180ms ease-in-out;
  z-index: 10000;
`
